import React, { useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router-dom';
import AppBar from './AppBar';
import Sidebar from './SideBar';
import { neverShowLayout } from '../../configs/routes';
import { useDispatch, useSelector } from 'react-redux';
import { isAuthenticatedSelector } from '../../store/user/user.selector';
import { getOrgInfo } from '../../apis/user';
import { setUser } from '../../store/user/user.reducer';

const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const dispatch = useDispatch();
  const isAuth = useSelector(isAuthenticatedSelector);
  const getUserAdminInfo = () => {
    getOrgInfo()
      .then((res) => dispatch(setUser(res)))
      .catch((e) => console.log({ e }));
  };

  useEffect(() => {
    if (isAuth) getUserAdminInfo();
  }, [isAuth]);

  if (neverShowLayout.includes(pathname)) return <main className='main-layout'>{children}</main>;

  return (
    <main className='main-layout'>
      <AppBar />
      <Box className='sidebar'>
        <Sidebar />
      </Box>
      <Box className='scrollable-content'>{children}</Box>
    </main>
  );
};

export default Layout;
